import { authHeaders, betterFetch, CCS_URL } from './helper';

/**
 * checks whether name of the component is available for new component or not
 * @param {string} id - of the component
 * @param {string} componentName - name of the component
 * @returns {Promise<Response>} the response object
 */
export const createFlashEventPage = function createFlashEventPage({
  cwd,
  flashEventPageRunAsOf,
  pageCategory,
  pageId,
  pageName
}) {
  const headers = authHeaders();
  const payload = {
    eventsApiCategory: pageCategory,
    eventsApiRunAsOf: flashEventPageRunAsOf,
    pageId,
    pageName,
    parentFolderId: cwd
  };
  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  };
  return betterFetch(`${CCS_URL}/workflow/flash-event`, options);
};
